import React from 'react';

/**
 * Currency Modal Component
 * 
 * Fields:
 * - Name: textfield (e.g., US Dollar, Indian Rupee)
 * - Symbol: textfield (e.g., $, ₹, €)
 * - Default: checkbox (only one currency can be default)
 * - Active: checkbox
 */
const CurrencyModal = ({ show, onClose, onSave, initial = {}, defaultItem = null }) => {
  const [name, setName] = React.useState(initial.name || '');
  const [symbol, setSymbol] = React.useState(initial.symbol || '');
  const [isDefault, setIsDefault] = React.useState(initial.is_default ?? false);
  const [active, setActive] = React.useState(initial.active ?? true);

  React.useEffect(() => {
    setName(initial.name || '');
    setSymbol(initial.symbol || '');
    setIsDefault(initial.is_default ?? false);
    setActive(initial.active ?? true);
  }, [initial]);

  if (!show) return null;

  return (
    <div className="modal-backdrop d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal d-block" tabIndex={-1} role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{initial.id ? 'Edit' : 'Add'} {initial.title || 'Currency'}</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
            </div>
            <div className="modal-body">
              {/* Name field */}
              <div className="mb-3">
                <label className="form-label">Name <span className="text-danger">*</span></label>
                <input 
                  className="form-control" 
                  value={name} 
                  onChange={(e) => setName(e.target.value)} 
                  placeholder="e.g., US Dollar, Indian Rupee, Euro"
                />
              </div>

              {/* Symbol field */}
              <div className="mb-3">
                <label className="form-label">Symbol <span className="text-danger">*</span></label>
                <input 
                  className="form-control" 
                  value={symbol} 
                  onChange={(e) => setSymbol(e.target.value)} 
                  placeholder="e.g., $, ₹, €, £"
                />
                <small className="text-muted">Enter the currency symbol (1-5 characters)</small>
              </div>

              {/* Default checkbox */}
              <div className="form-check form-switch mb-3">
                <input 
                  className="form-check-input" 
                  type="checkbox" 
                  id="modalIsDefault" 
                  checked={isDefault} 
                  onChange={(e) => setIsDefault(e.target.checked)} 
                />
                <label className="form-check-label ms-2" htmlFor="modalIsDefault">Default</label>
                {isDefault && (
                  <small className="d-block text-muted mt-1">
                    This will be the default currency
                  </small>
                )}
              </div>

              {/* Active checkbox */}
              <div className="form-check form-switch mb-3">
                <input 
                  className="form-check-input" 
                  type="checkbox" 
                  id="modalActive" 
                  checked={active} 
                  onChange={(e) => setActive(e.target.checked)} 
                />
                <label className="form-check-label ms-2" htmlFor="modalActive">Active</label>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
              <button 
                type="button" 
                className="btn btn-primary" 
                onClick={() => onSave({ 
                  ...initial, 
                  name: name.trim(), 
                  symbol: symbol.trim(),
                  is_default: isDefault,
                  active
                })} 
                disabled={!name.trim() || !symbol.trim()}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyModal;
